import * as React from "react"
import {TextFieldSeeker} from "@ui-seeker/core";

import {repricingFormErrors} from "../../@signals";
import {useRepricingFormData} from "../@hooks";


export default function RepricingFormNameTextField() {
	const { name, handleChangeValue } = useRepricingFormData()

    return <TextFieldSeeker
		error={repricingFormErrors.value.name}
		label="Rule name"
		value={name}
		onChange={e => handleChangeValue('name', e.target.value)}
	/>
}